/* eslint-disable */
/* prettier-ignore-file */
//libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
//components
import Loading from '../../UI_Elements/Loading';
import SelectField from '../../UI_Elements/Forms/Form_Elements/SelectField';
import TextField from '../../UI_Elements/Forms/Form_Elements/TextField';
import DateTimeField from '../../UI_Elements/Forms/Form_Elements/DateTimeField';
import ReadOnlyField from '../../UI_Elements/Forms/Form_Elements/ReadOnlyField';
//other
import { notification } from '../../../helpers';
import { post, put } from '../../../actions/cars';

class CreateCarForm extends Component {
    constructor(props) {
        super(props);

        let id,
            wheelType,
            regNo,
            waggonNo,
            retailerId,
            carModel,
            offRentDate,
            returnInventLocationId,
            lastOnRentDate;
        id =
            regNo =
            waggonNo =
            retailerId =
            carModel =
            offRentDate =
            returnInventLocationId =
            lastOnRentDate =
            '';
        wheelType = 2;

        if (typeof props.car !== 'undefined') {
            const car = props.car;
            id = car.id;
            wheelType = car.wheelType;
            regNo = car.regNo;
            waggonNo = car.waggonNo;
            retailerId = car.retailerId;
            carModel = car.carModel;
            offRentDate = car.offRentDate;
            returnInventLocationId = car.returnInventLocationId;
            lastOnRentDate = car.lastOnRentDate;
        }

        this.state = {
            id: id,
            wheelType: wheelType,
            regNo: regNo,
            waggonNo: waggonNo,
            retailerId: retailerId,
            carModel: carModel,
            offRentDate: offRentDate,
            returnInventLocationId: returnInventLocationId,
            lastOnRentDate: lastOnRentDate,
        };
    }

    validateFormFiled(value, field) {
        let x = null;
        if (field.validations) {
            for (x in field.validations) {
                switch (field.validations[x].type) {
                    case 'minLenght':
                        if (value.length < field.validations[x].value) {
                            return false;
                        }
                        break;
                    case 'maxLenght':
                        if (value.length > field.validations[x].value) {
                            return false;
                        }
                        break;
                    case 'equalLenght':
                        if (value.length !== field.validations[x].value) {
                            return false;
                        }
                        break;
                    default:
                        //going to next
                        break;
                }
            }
        }

        if (field.required && (!value || value.lenght === 0)) {
            return false;
        }

        return true;
    }

    validateForm() {
        // return this.state.email.length > 0;
        const formFields = this.getFormFields();
        let x = null;
        for (x in formFields) {
            if (typeof this.state[formFields[x].id] !== 'undefined') {
                if (!this.validateFormFiled(this.state[formFields[x].id], formFields[x])) {
                    return false;
                }
            }
        }

        return true;
    }

    handleChange(event) {
        event.preventDefault();
        event.stopPropagation();

        var value = event.target.value;

        switch (event.target.name) {
            default: this.setState({
                [event.target.name]: value,
            });
            break;
        }
    }

    handleChangeDate(id, date) {
        this.setState({
            [id]: date,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.validateForm()) {
            let data = {
                ...this.state,
            };

            data.lastOnRentDate = moment(data.lastOnRentDate).format('YYYY-MM-DD');
            data.offRentDate = moment(data.offRentDate).format('YYYY-MM-DD');

            if (data.offRentDate === 'Invalid date') {
                data.offRentDate = null;
            }
            if (data.lastOnRentDate === 'Invalid date') {
                data.lastOnRentDate = null;
            }

            if (this.state.id) {
                data = {
                    id: data.id,
                    lastOnRentDate: data.lastOnRentDate,
                    winterWheelType: data.wheelType,
                };
                this.props.put(data);
            } else {
                data.winterWheelType = data.wheelType;
                delete data.id;
                delete data.wheelType;
                this.props.post(data);
            }
        } else {
            notification('Några fält saknas eller felaktig form!');
        }
    }

    getFormFields() {
        const formFields = [{
                id: 'wheelType',
                title: 'wheelType',
                value: this.state.wheelType,
                fieldType: 'select',
                required: true,
                options: [{
                        id: 2,
                        title: 'Spikes',
                    },
                    {
                        id: 3,
                        title: 'Friction',
                    },
                ],
                canEdit: true,
            },
            {
                id: 'regNo',
                title: 'regNo',
                placeholder: 'regNo',
                value: this.state.regNo,
                fieldType: 'text',
                required: true,
                lenght: 6,
                canEdit: false,
                validations: [{
                    type: 'equalLenght',
                    value: 6,
                }, ],
            },
            {
                id: 'waggonNo',
                title: 'waggonNo',
                placeholder: 'waggonNo',
                value: this.state.waggonNo,
                fieldType: 'text',
                required: true,
                // lenght:5,
                canEdit: false,
                validations: [{
                    type: 'minLenght',
                    value: 5,
                }, ],
            },
            {
                id: 'retailerId',
                title: 'retailerId',
                placeholder: 'retailerId',
                value: this.state.retailerId,
                fieldType: 'text',
                required: true,
                // lenght:5,
                canEdit: false,
            },
            {
                id: 'carModel',
                title: 'carModel',
                placeholder: 'carModel',
                value: this.state.carModel,
                fieldType: 'text',
                required: true,
                // lenght:5,
                canEdit: false,
            },
            {
                id: 'offRentDate',
                title: 'offRentDate',
                placeholder: 'offRentDate',
                value: this.state.offRentDate,
                fieldType: 'datetime',
                required: false,
                // lenght:5,
                canEdit: false,
            },
            {
                id: 'returnInventLocationId',
                title: 'returnInventLocationId',
                placeholder: '',
                value: this.state.returnInventLocationId,
                fieldType: 'text',
                required: false,
                // lenght:5,
                canEdit: false,
            },
            {
                id: 'lastOnRentDate',
                title: 'lastOnRentDate',
                placeholder: 'lastOnRentDate',
                value: this.state.lastOnRentDate,
                fieldType: 'datetime',
                required: false,
                // lenght:5,
                canEdit: true,
            },
        ];

        return formFields;
    }

    render() {
        let buttonTitle = 'Skapa bilhjulstyp';
        if (this.state.id) {
            buttonTitle = 'Uppdatera hjulstyp';
        }

        const { submitting } = this.props;
        const formFields = this.getFormFields();

        return (
            <div className="box create-car">
                <div className="box-inner">
                    <h2>{buttonTitle}</h2>
                    <Loading show={submitting} />
                    {!submitting && (
                        <form onSubmit={this.handleSubmit}>
                            {formFields.map((field, index) => {
                                if (this.state.id && !field.canEdit) {
                                    // Format date fields for read-only display
                                    const displayField = {...field};
                                    if (field.fieldType === 'datetime') {
                                        if (field.value) {
                                            const formatted = moment(field.value).format('YYYY-MM-DD');
                                            displayField.value = formatted === 'Invalid date' ? '' : formatted;
                                        } else {
                                            displayField.value = '';
                                        }
                                        displayField.placeholder = '';
                                    }
                                    return <ReadOnlyField {...displayField} key={index} />;
                                }
                                switch (field.fieldType) {
                                    case 'text':
                                        return (
                                            <TextField
                                                {...field}
                                                key={index}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        );
                                    case 'select':
                                        return (
                                            <SelectField
                                                {...field}
                                                key={index}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        );
                                    case 'datetime':
                                        return (
                                            <DateTimeField
                                                {...field}
                                                key={index}
                                                onChange={(id, date) =>
                                                    this.handleChangeDate(id, date)
                                                }
                                            />
                                        );
                                    default:
                                        return '';
                                }
                            })}
                            <input
                                disabled={
                                    typeof this.state.groupType === 'undefined' &&
                                    this.state.groupType === 'Ingen'
                                }
                                type="submit"
                                className="submit creategroupsubmit form-submit"
                                value={buttonTitle}
                                onClick={(e) => this.handleSubmit(e)}
                            />
                        </form>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToPropsForCreateGroup = (state) => {
    return {
        submitting: state.stations.submitting,
    };
};

const mapDispatchToPropsForCreateGroup = (dispatch) => {
    return {
        post: (data) => dispatch(post(data)),
        put: (data) => dispatch(put(data)),
    };
};

export default connect(
    mapStateToPropsForCreateGroup,
    mapDispatchToPropsForCreateGroup
)(CreateCarForm);


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/CreateCarForm.js